import React, { useState } from 'react';
import TextEditor from "../../../../Util/TextEditor/TextEditor";
import { config } from "../../../../config";
import { messages } from "../../../../messages";
import axiosApi from './../../../../core/interceptor/interceptor';

function ReplyContactUs(props) {
	const [emailData, setEmailData] = useState({
		body: ''
	})
	const [errors, setErrors] = useState({
		message: '',
	});
	const handleFormChange = (event) => {
		setEmailData((previousEmailData) => ({
			...previousEmailData,
			[event.target.name]: event.target.value,
		}));
	}

	const handleValidation = () => {
		const errorArr = {};
		let formIsValid = true;

		/***** name validation ******/
		if (!emailData['body']) {
			formIsValid = false;
			errorArr["body"] = messages && messages.enterMessage;
		}
		setErrors(errorArr);
		return formIsValid;
	}

	const sendEmail = () => {
		if (handleValidation()) {
			axiosApi.post(`${config.apiUrl}/contact-us/${props.data.id}`, {
				reply: emailData.body,
			})
				.then(() => {
					setEmailData({ body: '', subject: '' });
					props.refresh?.();
				});
		}
	}

	return (
		<div className="modal">
			<div className="add-adminModal">
				<div className="input-field">
					<TextEditor
						value={emailData.body}
						name="body" onChange={(body) => handleFormChange({ target: { name: 'body', value: body } })}
					/>
					<span className="error">{errors['body']}</span>
				</div>
			</div>
			<div className="modal-footer d-flex">
				<button className="search-btn" onClick={sendEmail}>Send Reply</button>
			</div>
		</div>
	)
}

export default ReplyContactUs;